import req from 'utils/req';

export default {
  getV1CurrencyRates: () =>
    req(`${URL_API_HOST}/api/v1/finance/currency/rates`).get(),
  getV2CurrencyRates: (targetCurrency) =>
    req(
      `${URL_API_HOST}/api/v2/finance/currency/rates/${targetCurrency}`,
    ).get(),
};
